import React from 'react';
import { Link } from 'react-router-dom';

const NotImplementedPage = () => {
  return (
    <div className="error-page">
      <h1>501 Not Implemented</h1>
      <p>The server does not support the functionality required to fulfill the request.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default NotImplementedPage;
